var indexEs5;
var hasRequiredIndexEs5;
function requireIndexEs5() {
  if (hasRequiredIndexEs5) return indexEs5;
  hasRequiredIndexEs5 = 1;
  var pattern = /-(\w|$)/g;
  var callback = function callback2(dashChar, char) {
    return char.toUpperCase();
  };
  var camelCaseCSS = function camelCaseCSS2(property) {
    property = property.toLowerCase();
    if (property === "float") {
      return "cssFloat";
    } else if (property.charCodeAt(0) === 45 && property.charCodeAt(1) === 109 && property.charCodeAt(2) === 115 && property.charCodeAt(3) === 45) {
      return property.substr(1).replace(pattern, callback);
    } else {
      return property.replace(pattern, callback);
    }
  };
  indexEs5 = camelCaseCSS;
  return indexEs5;
}
export {
  requireIndexEs5 as __require
};
//# sourceMappingURL=index-es5.js.map
